import React, { useContext, useState, useEffect } from 'react';
import { Row, Col, Table } from 'react-bootstrap';
import mLaporan from '../Laporan.controler'
import moment from 'moment-timezone'
import CurrencyFormat from 'react-currency-format';
import AuthContext from '../../../../context/auth-context'
import { makeStyles } from '@material-ui/core/styles';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import ImportExportIcon from '@material-ui/icons/ImportExport';

const numberWithCommas = (x) => {
    if (!x) x = 0;
    const a = parseFloat(Math.round(x * 100) / 100).toFixed(2)
    return a.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const SessionDetail = (props) => {
    const classes = useStyles();
    const dataDetail = props.dataDetail
    const IDSession = props.IDSession
    const [isRefresh, setIsRefresh] = useState(true)
    const { clientID, token, userLogin } = useContext(AuthContext);
    const [itemDetail, setItemDetail] = useState([])
    const [subkategori, setSubkategori] = useState([])
    const [hasil, setHasil] = useState({})
    const [pembayaran, setPembayaran] = useState({})
    const [listNonTunai, setListNonTunai] = useState([])
    const [isNullSubKat, setIsNullSubKat] = useState(false)
    var subTotal = 0
    var subTotalNull = 0
    var totalItemNull = 0

    useEffect(() => {
        var render = true
        if (isRefresh) {
            mLaporan.laporanSessionDetail(clientID, token, userLogin, props.idOutlet, IDSession).then(resp => {
                setHasil(resp.detailHasil)
                setSubkategori(resp.subkategoriFinal)
                setItemDetail(resp.detaiItemGroupSort)
                setPembayaran(resp.pembayaran)
                setListNonTunai(resp.listNonTunai)
                setIsNullSubKat(resp.isNullSubkategori)
            }).catch(err => {
                console.error(err);
            }).finally(() => setIsRefresh(false))
        }
        return () => {
            render = false
        };
    }, [isRefresh])

    const namaExport = () => {
        return (
            <React.Fragment>
                <ImportExportIcon />  Export Excel
            </React.Fragment>
        )
    }

    return (
        <React.Fragment>
            <Row >
                <Col xs={12} c className={`${classes.contentBody} bodySessionDetail`}>
                    <ReactHTMLTableToExcel
                        className="buttonExportExcel"
                        table="laporanPerSession"
                        filename={`Laporan per session id ${IDSession}`}
                        sheet="Sheet1"
                        buttonText={namaExport()} />
                    <div className="sessionDetail">
                        <Table id="laporanPerSession" bordered hover responsive size="sm">
                            <thead>
                                <tr>
                                    <th colSpan="3">Mulai : {moment(dataDetail.tanggalBuka).format("DD-MM-YYYY HH:mm")}</th>
                                </tr>
                                {dataDetail.userTutup && (
                                    <tr>
                                        <th colSpan="3">Selesai : {(moment(dataDetail.tanggalTutup).format("DD-MM-YYYY HH:mm"))}</th>
                                    </tr>
                                )}
                                <tr>
                                    <th colSpan="3">Akun : {dataDetail.userBuka} </th>
                                </tr>
                                <tr>
                                    <th colSpan="3">Saldo Awal : {numberWithCommas(dataDetail.saldoAwal)} </th>
                                </tr>
                            </thead>
                            <tbody>
                                {subkategori.map((subkategori, index) => {
                                    var totalItem = 0
                                    return (
                                        <React.Fragment key={index}>
                                            <tr className="boderSession">
                                                <td colSpan="3">{subkategori.namasubkategori}</td>
                                            </tr>
                                            {itemDetail.filter(item => {
                                                return item.kodesubkategori === subkategori.kodesubkategori
                                            }).map((item, idx) => {
                                                totalItem += item.jumlah
                                                subTotal += item.jumlah
                                                return (
                                                    <tr key={idx}>
                                                        <td>{item.namabarang}</td>
                                                        <td style={{ width: '20px' }}>{item.qty}</td>
                                                        <td className="text-right"><CurrencyFormat value={parseFloat(Math.round(item.jumlah * 100) / 100).toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={''} renderText={value => <div>{value}</div>} /></td>
                                                    </tr>
                                                )
                                            })}
                                            <tr className="boderSession">
                                                <td colSpan="2">Total</td>
                                                <td className="text-right"><CurrencyFormat value={parseFloat(Math.round(totalItem * 100) / 100).toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={''} renderText={value => <div>{value}</div>} /></td>
                                            </tr>
                                        </React.Fragment>
                                    )
                                })}
                                {isNullSubKat && (
                                    <React.Fragment>
                                        <tr className="boderSession">
                                            <td colSpan="3">NaN</td>
                                        </tr>
                                        {itemDetail.filter(item => {
                                            return item.kodesubkategori === "tidakadasubkategori"
                                        }).map((item, idx) => {
                                            totalItemNull += item.jumlah
                                            subTotalNull += item.jumlah
                                            return (
                                                <tr key={idx}>
                                                    <td>{item.namabarang}</td>
                                                    <td style={{ width: '20px' }}>{item.qty}</td>
                                                    <td className="text-right"><CurrencyFormat value={parseFloat(Math.round(item.jumlah * 100) / 100).toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={''} renderText={value => <div>{value}</div>} /></td>
                                                </tr>
                                            )
                                        })}
                                        <tr className="boderSession">
                                            <td colSpan="2">Total</td>
                                            <td className="text-right"><CurrencyFormat value={parseFloat(Math.round(totalItemNull * 100) / 100).toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={''} renderText={value => <div>{value}</div>} /></td>
                                        </tr>
                                    </React.Fragment>
                                )}
                                <tr className="boderSession">
                                    <th colSpan="2">Sub Total</th>
                                    <th className="text-right"><CurrencyFormat value={parseFloat(Math.round((subTotal + subTotalNull) * 100) / 100).toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={''} renderText={value => <div>{value}</div>} /></th>
                                </tr>
                                <tr>
                                    <th colSpan="2">Diskon</th>
                                    <th className="text-right"><CurrencyFormat value={parseFloat(Math.round(hasil.discountAmount * 100) / 100).toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={''} renderText={value => <div>{value}</div>} /></th>
                                </tr>
                                <tr>
                                    <th colSpan="2">Service</th>
                                    <th className="text-right"><CurrencyFormat value={parseFloat(Math.round(hasil.serviceAmount * 100) / 100).toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={''} renderText={value => <div>{value}</div>} /></th>
                                </tr>
                                <tr>
                                    <th colSpan="2">Tax</th>
                                    <th className="text-right"><CurrencyFormat value={parseFloat(Math.round(hasil.taxAmount * 100) / 100).toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={''} renderText={value => <div>{value}</div>} /></th>
                                </tr>
                                <tr>
                                    <th colSpan="2">Total</th>
                                    <th className="text-right"><CurrencyFormat value={parseFloat(Math.round(hasil.total * 100) / 100).toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={''} renderText={value => <div>{value}</div>} /></th>
                                </tr>
                                <tr className="boderSession">
                                    <th colSpan="2">Tunai</th>
                                    <th className="text-right"><CurrencyFormat value={parseFloat(Math.round(pembayaran.tunai * 100) / 100).toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={''} renderText={value => <div>{value}</div>} /></th>
                                </tr>
                                {dataDetail.userTutup && (
                                    <React.Fragment>
                                        <tr>
                                            <th colSpan="2">Kas Akhir</th>
                                            <th className="text-right"><CurrencyFormat value={parseFloat(Math.round((dataDetail.saldoAwal + pembayaran.tunai) * 100) / 100).toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={''} renderText={value => <div>{value}</div>} /></th>
                                        </tr>
                                        <tr>
                                            <th colSpan="2">Saldo Akhir</th>
                                            <th className="text-right"><CurrencyFormat value={parseFloat(Math.round(dataDetail.saldoAkhir * 100) / 100).toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={''} renderText={value => <div>{value}</div>} /></th>
                                        </tr>
                                        <tr>
                                            <th colSpan="2">Selisih</th>
                                            <th className="text-right">
                                                <CurrencyFormat value={parseFloat(Math.round((dataDetail.saldoAkhir - (dataDetail.saldoAwal + pembayaran.tunai)) * 100) / 100).toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={''} renderText={value => <div>{value}</div>} />
                                            </th>
                                        </tr>
                                    </React.Fragment>
                                )}
                                {listNonTunai.map((data, index) => {
                                    return (
                                        <tr key={index} className={index == 0 && ("boderSession")}>
                                            <th colSpan="2">{data.namapayment}</th>
                                            <th className="text-right"><CurrencyFormat value={parseFloat(Math.round(data.amount * 100) / 100).toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={''} renderText={value => <div>{value}</div>} /></th>
                                        </tr>
                                    )
                                })}

                                <tr>
                                    <th colSpan="2">Total Non Tunai</th>
                                    <th className="text-right"><CurrencyFormat value={parseFloat(Math.round(pembayaran.nontunai * 100) / 100).toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={''} renderText={value => <div>{value}</div>} /></th>
                                </tr>
                            </tbody>
                        </Table>
                    </div>
                </Col>
            </Row>
            <Row className="marginGrafik"></Row>
        </React.Fragment>

    )
}


export default SessionDetail;
const useStyles = makeStyles(theme => ({
    contentBody: {
        height: window.innerHeight - 200,
    },
}));